export const GENERAL_PAGE_ACCESS_ID = 'utbud';
export const GENERAL_PAGE_ACCESS_ID_FI = 'tarjonta';

export const isGeneralPage = (accessId: string) =>
  accessId === GENERAL_PAGE_ACCESS_ID ||
  accessId === GENERAL_PAGE_ACCESS_ID_FI ||
  accessId === undefined;
